import { pollScanResults } from '@/api/funkcheck/FunkcheckApi';
import { useFunkcheckStore } from '@/store/funkcheck/funkcheckStore';

export class ActiveFunkcheck {
  businessEntityID: string;
  gatewaySerialNumber: string;
  initResult: InitResultData;
  attempt: number;
  startedAt: Date | null;
  scanResult: ScanResult | null;

  constructor(
    businessEntityID: string,
    gatewaySerialNumber: string,
    initResult: InitResultData
  ) {
    this.businessEntityID = businessEntityID;
    this.gatewaySerialNumber = gatewaySerialNumber;
    this.initResult = initResult;
    this.attempt = 0;
    this.startedAt = null;
    this.scanResult = null;
  }
}

const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));

export const receiveScanResults = async (
  gatewaySerialNumber: string,
  intervals: number[],
  startedAtISO: string
): Promise<ScanResult> => {
  console.debug('Start scan...');
  if (!intervals.length) throw new Error('No polling intervals provided');

  const store = useFunkcheckStore();
  const startedAt = new Date(startedAtISO);

  const validate = (result: ScanResult): boolean => {
    const finishedAt = result?.data?.finishedAt
      ? new Date(result.data.finishedAt)
      : null;
    const createdAt = result?.data?.createdAt;
    return Boolean(finishedAt && createdAt && finishedAt > startedAt);
  };

  console.debug(`attempt: 0 polling in: ${intervals[0]}`);
  await sleep(intervals[0]);

  for (let attempt = 1; attempt <= intervals.length; attempt++) {
    console.debug('polling...');

    let result: ScanResult | null = null;
    try {
      result = await pollScanResults(gatewaySerialNumber);
      console.debug('poll result:', result);
    } catch (err) {
      console.debug('poll error, will retry:', err);
    }

    if (result?.data && validate(result)) {
      store.updateActiveFunkcheck(0, null);
      return result;
    }

    if (attempt === intervals.length) break;

    store.updateActiveFunkcheck(attempt, new Date());
    console.debug(`attempt: ${attempt} polling in: ${intervals[attempt]}`);
    await sleep(intervals[attempt]);
  }

  store.updateActiveFunkcheck(0, null);
  throw new Error('Exceeded max attempts');
};
